import { create } from 'zustand'

export type Severity = 'success' | 'error' | 'warning' | 'info'

interface SnackbarState {
    open: boolean
    message: string
    severity: Severity
    duration?: number | null
    showMessage: (message: string, severity: Severity, duration?: number | null) => void
    closeMessage: () => void
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
    open: false,
    message: '',
    severity: 'info',
    duration: 5000,
    showMessage: (message, severity = 'info', duration = 5000) => set({ open: true, message, severity, duration }),
    closeMessage: () => set({ open: false, message: '' }),
}))
